import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Spinner } from "reactstrap";
import { getDashboardData } from "../../services/reportesService";
import ServiciosAdicionales from "../Dashboard/components/ServiciosAdicionales";

const ServiciosAdicionalesDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await getDashboardData();
        setData(response?.data?.servicios_adicionales || null);
      } catch (err) {
        console.error("Error cargando Servicios Adicionales:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <ServiciosAdicionales data={data} loading={loading} />
      </Container>
    </div>
  );
};

export default ServiciosAdicionalesDashboard;